import { View, Text } from "react-native";
import { FormControlledRadioGroup } from "ui/molecules/form/FormControlledRadioGroup";
import { Control, useWatch } from "react-hook-form";
import { CreateCalendarEventForm } from "app/services/api/types/calendar/requests/CreateCalendarEventForm";
import { FrequencyEnums } from "app/services/api/types/calendar/enums/FrequencyEnums";
import { DailyRecurrenceOptions } from "./DailyRecurrenceOptions";
import { WeeklyRecurrenceOptions } from "./WeeklyRecurrenceOptions";
import { MonthlyRecurrenceOptions } from "./MonthlyRecurrenceOptions";
import { YearlyRecurrenceOptions } from "./YearlyRecurrenceOptions";
import { requiredValidation } from "ui/utils/Validators";

interface RecurrencePatternProps {
  control: Control<CreateCalendarEventForm>;
}

export function RecurrencePattern({ control }: RecurrencePatternProps) {
  const frequencyArray = useWatch({
    control,
    name: "recurrence_rule.frequency",
  });

  const frequency = Array.isArray(frequencyArray)
    ? frequencyArray[0]
    : frequencyArray || undefined;

  const frequencyOptions = [
    {
      label: "Never",
      value: FrequencyEnums.NEVER,
    },
    {
      label: "Daily",
      value: FrequencyEnums.DAILY,
    },
    {
      label: "Weekly",
      value: FrequencyEnums.WEEKLY,
    },
    {
      label: "Monthly",
      value: FrequencyEnums.MONTHLY,
    },
    {
      label: "Yearly",
      value: FrequencyEnums.YEARLY,
    },
  ];

  const renderRecurrenceForm = () =>
    frequency === FrequencyEnums.NEVER ? (
      <Text className="text-sm text-gray-500 ">
        This is applicable for a one-off event that never repeats.
      </Text>
    ) : frequency === FrequencyEnums.DAILY ? (
      <DailyRecurrenceOptions control={control} />
    ) : frequency === FrequencyEnums.WEEKLY ? (
      <WeeklyRecurrenceOptions control={control} />
    ) : frequency === FrequencyEnums.MONTHLY ? (
      <MonthlyRecurrenceOptions control={control} />
    ) : frequency === FrequencyEnums.YEARLY ? (
      <YearlyRecurrenceOptions control={control} />
    ) : (
      <Text>Select a recurrence pattern</Text>
    );

  return (
    <View>
      <Text className="text-gray-500 mb-4">Repeat</Text>

      <View className="grid grid-cols-12 gap-3">
        <View className="col-span-12 sm:col-span-5 border border-secondary-50 rounded-xl p-6">
          <FormControlledRadioGroup
            id="recurrence_frequency"
            name="recurrence_rule.frequency"
            control={control}
            options={frequencyOptions}
            isRequired
            rules={{
              required: requiredValidation("Appointment frequency"),
            }}
          />
        </View>

        <View className="col-span-12 sm:col-span-7 border border-secondary-50 rounded-xl p-6 justify-center">
          {renderRecurrenceForm()}
        </View>
      </View>
    </View>
  );
}
